export default __webpack_public_path__ + "static/media/itinerary2_800.c8508568.webp";